/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSmsTemplateRequest
 */
export interface UpdateSmsTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSmsTemplateRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSmsTemplateRequest
     */
    content: string;
}

/**
 * Check if a given object implements the UpdateSmsTemplateRequest interface.
 */
export function instanceOfUpdateSmsTemplateRequest(value: object): value is UpdateSmsTemplateRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function UpdateSmsTemplateRequestFromJSON(json: any): UpdateSmsTemplateRequest {
    return UpdateSmsTemplateRequestFromJSONTyped(json, false);
}

export function UpdateSmsTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSmsTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'content': json['content'],
    };
}

export function UpdateSmsTemplateRequestToJSON(json: any): UpdateSmsTemplateRequest {
    return UpdateSmsTemplateRequestToJSONTyped(json, false);
}

export function UpdateSmsTemplateRequestToJSONTyped(value?: UpdateSmsTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'content': value['content'],
    };
}

